import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const AllVppasStyles = css`
  ${MainStyles}

  .grid-styles {
    width: 100%;
    height: 100%;
  }
  .no-criteria-wrapper {
    position: absolute;
    width: 100%;
    height: calc(100% - 83px);
    top: 83px;
    background-color: var(--neutral-layer-3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
